import projectIcon1 from 'assets/images/default_project_picture_icons/1_256.png';
import projectIcon2 from 'assets/images/default_project_picture_icons/2_256.png';
import projectIcon3 from 'assets/images/default_project_picture_icons/3_256.png';
import projectIcon4 from 'assets/images/default_project_picture_icons/4_256.png';
import { OrganizationSubproject } from 'views/ProFormaTable/types';
import { DealLite } from 'views/Deals/hooks/useGetOrganizationDealsLite';

const COVER_PICTURE_ICONS: Record<string, string> = {
    'default_cover_picture1.png': projectIcon1,
    'default_cover_picture2.png': projectIcon2,
    'default_cover_picture3.png': projectIcon3,
    'default_cover_picture4.png': projectIcon4,
};

export const coverPictureToIcon = (coverPicture?: string | null): string => (
    COVER_PICTURE_ICONS[coverPicture ?? ''] ?? projectIcon1
);


export const matchesProjectSearch = (project: OrganizationSubproject, term: string): boolean => {
    const query = term.trim().toLowerCase();
    if (!query) return true;
    const name = project.subproject.subprojectName?.toLowerCase() || '';
    const developmentSiteName = project.subproject.developmentProject.projectName?.toLowerCase() || '';
    return name.includes(query) || developmentSiteName.includes(query);
};

export const matchesDealSearch = (deal: DealLite, term: string): boolean => {
    const query = term.trim().toLowerCase();
    if (!query) return true;
    return deal.dealName.toLowerCase().includes(query);
};